module.exports = __webpack_public_path__ + "media/tutorial-clip.3991917c.mp4";